export class ProjectPermissionConstants {
  public static readonly READ_PROJECT = "readProject";

  public static readonly READ_PROJECT_ACTIVITY = "readProjectActivity";

  public static readonly READ_ALL_PROJECT_AUDIT = "readAllProjectAudit";

  public static readonly READ_OWN_ORG_PROJECT_AUDIT = "readOwnOrgProjectAudit";

  public static readonly WRITE_PROJECT_DATES = "writeProjectDates";

  public static readonly WRITE_PROJECT_DETAILS = "writeProjectDetails";

  public static readonly WRITE_PROJECT_LISTING = "writeProjectListing";

  public static readonly WRITE_PROJECT_ACTIVITY = "writeProjectActivity";

  public static readonly WRITE_PROJECT_ACTIVITY_REVIEW = "writeProjectActivityReview";

  public static readonly MANAGE_PROJECT_ACTIVITY = "manageProjectActivity";

  public static readonly MANAGE_PROJECT_ACTIVITY_REVIEW = "manageProjectActivityReview";

  public static readonly MANAGE_PROJECT_DOCUMENT = "manageProjectDocument";

  public static readonly MANAGE_PROJECT_ISSUANCES = "manageProjectIssuances";

  public static readonly DOWNLOAD_PROJECT_ACTIVITY_OUTPUT = "downloadProjectActivityOutput";

  public static readonly MERGE_PROJECT = "mergeProject";

  public static readonly DELETE_PROJECT = "deleteProject";

  public static readonly MANAGE_PROJECT_ORGANISATION_INVITATION = "manageProjectOrganisationInvitation";

  public static readonly MANAGE_GROUP = "manageGroup";

  public static readonly ACCEPT_REJECT_PROJECT_ORGANISATION_INVITATION = "acceptRejectProjectOrganisationInvitation";
}
